export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '统筹单流水号',
            minWidth: 150
        },
        {
            prop: 'orgName',
            label: '所属机构',
            minWidth: 200
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'carType',
            label: '车型',
            minWidth: 100
        },
        {
            prop: 'beginTime',
            label: '统筹起期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '统筹止期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'contractFee',
            label: '标准统筹费',
            minWidth: 100,
        },
        {
            prop: 'cusRebate',
            label: '整单折扣',
            minWidth: 100,
        },
        {
            prop: 'cusFee',
            label: '应交统筹费',
            minWidth: 100,
        },
        {
            prop: 'customerRebate',
            label: '客户折扣',
            minWidth: 100,
        },
        {
            prop: 'customerFee',
            label: '客户统筹费',
            minWidth: 100,
        },
        {
            prop: 'cashRebate',
            label: '费用政策(%)',
            minWidth: 150,
        },
        {
            prop: 'netFee',
            label: '净费',
            minWidth: 150,
        },
        {
            prop: 'realInFee',
            label: '实收金额(元)',
            minWidth: 100,
        },
        {
            prop: 'diffe',
            label: '差额（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'auditName',
            label: '审核人',
            minWidth: 100
        },
        {
            prop: 'auditTime',
            label: '审核时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'fauditName',
            label: '财务审核',
            minWidth: 100
        },
        {
            prop: 'fauditTime',
            label: '财务审核时间',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'real_pay_time',
            label: '实际支付时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'creatorName',
            label: '制单人',
            minWidth: 100
        },
        {
            prop: 'saleName',
            label: '业务员',
            minWidth: 100
        },
        {
            prop: 'create_time',
            label: '创建时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'pd_remark',
            label: '备注',
            minWidth: 200
        },
        {
            prop: 'effectTime',
            label: '生效时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'payTime',
            label: '交费日期',
            sortable: true,
            minWidth: 200
        }

    ]
}

export default {}